import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Alert, Card } from 'react-bootstrap';
import api from '../services/api';

const RTI = () => {
  const [departments, setDepartments] = useState([]);
  const [formData, setFormData] = useState({
    applicant_name: '',
    applicant_email: '',
    applicant_phone: '',
    applicant_address: '',
    subject: '',
    information_required: '',
    department: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [applicationNo, setApplicationNo] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    loadDepartments();
  }, []);

  const loadDepartments = async () => {
    try {
      const response = await api.get('/departments/');
      setDepartments(response.data);
    } catch (error) {
      console.error('Error loading departments:', error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const response = await api.post('/submit-rti/', formData);
      setApplicationNo(response.data.application_no);
      setSubmitted(true);
      setFormData({
        applicant_name: '',
        applicant_email: '',
        applicant_phone: '',
        applicant_address: '',
        subject: '',
        information_required: '',
        department: ''
      });
    } catch (error) {
      setError('Failed to submit application. Please try again.');
      console.error('Error submitting RTI:', error);
    }
  };

  return (
    <Container className="py-5">
      <h1 className="page-title mb-4">RTI Application</h1>
      
      <Card className="mb-4">
        <Card.Body>
          <Card.Title>Right to Information Act, 2005</Card.Title>
          <Card.Text>
            The RTI Act empowers citizens to seek information from public authorities. 
            Use this form to submit your RTI application.
          </Card.Text>
        </Card.Body>
      </Card>

      {submitted && (
        <Alert variant="success">
          <Alert.Heading>Application Submitted Successfully!</Alert.Heading>
          <p>Your RTI application number is: <strong>{applicationNo}</strong></p>
          <p>Please save this number for future reference.</p>
        </Alert>
      )}

      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Full Name *</Form.Label>
          <Form.Control
            type="text"
            name="applicant_name"
            value={formData.applicant_name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Email *</Form.Label>
          <Form.Control
            type="email"
            name="applicant_email"
            value={formData.applicant_email}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Phone *</Form.Label>
          <Form.Control
            type="tel"
            name="applicant_phone"
            value={formData.applicant_phone}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Address *</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="applicant_address"
            value={formData.applicant_address}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Department *</Form.Label>
          <Form.Select
            name="department"
            value={formData.department}
            onChange={handleChange}
            required
          >
            <option value="">Select Department</option>
            {departments.map(dept => (
              <option key={dept.id} value={dept.id}>{dept.name}</option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Subject *</Form.Label>
          <Form.Control
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Information Required *</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            name="information_required"
            value={formData.information_required}
            onChange={handleChange}
            required
            placeholder="Describe the information you are seeking..."
          />
        </Form.Group>

        <Button variant="primary" type="submit" size="lg">
          Submit Application
        </Button>
      </Form>
    </Container>
  );
};

export default RTI;
